import React from 'react';
import { BarChart as RechartsBarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell } from 'recharts';

const BarChart = ({ data, dataKeys, colors, height = 180, horizontal = false }) => {
  return (
    <ResponsiveContainer width="100%" height={height}>
      <RechartsBarChart 
        data={data} 
        layout={horizontal ? 'vertical' : 'horizontal'} 
        margin={{ top: 10, right: 10, left: -15, bottom: 5 }}
        barGap={8}
        barCategoryGap="20%"
      >
        <defs>
          {colors.map((color, index) => (
            <linearGradient key={`bar-gradient-${index}`} id={`bar-gradient-${index}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.95}/>
              <stop offset="100%" stopColor={color} stopOpacity={0.75}/>
            </linearGradient>
          ))}
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#E2E2E2" vertical={false} opacity={0.5} />
        {horizontal ? (
          <>
            <XAxis 
              type="number" 
              stroke="#94a3b8" 
              style={{ fontSize: '10px', fontWeight: 600 }}
              tickLine={false}
              axisLine={{ stroke: '#e2e8f0', strokeWidth: 1 }}
            />
            <YAxis 
              type="category" 
              dataKey="name" 
              stroke="#94a3b8" 
              style={{ fontSize: '10px', fontWeight: 600 }}
              tickLine={false}
              axisLine={{ stroke: '#e2e8f0', strokeWidth: 1 }}
            />
          </>
        ) : (
          <>
            <XAxis 
              dataKey="name" 
              stroke="#A8A9AD" 
              style={{ fontSize: '10px', fontWeight: 600, fill: '#101820' }}
              tickLine={false}
              axisLine={{ stroke: '#E2E2E2', strokeWidth: 1 }}
              tick={{ fill: '#101820' }}
            />
            <YAxis 
              stroke="#A8A9AD" 
              style={{ fontSize: '10px', fontWeight: 600 }}
              tickLine={false}
              axisLine={{ stroke: '#E2E2E2', strokeWidth: 1 }}
              tick={{ fill: '#A8A9AD' }}
            />
          </>
        )}
        <Tooltip 
          contentStyle={{ 
            backgroundColor: 'rgba(255, 255, 255, 0.98)', 
            border: '1px solid #E2E2E2',
            borderRadius: '10px',
            boxShadow: '0 10px 25px -5px rgba(0, 102, 255, 0.1), 0 8px 10px -6px rgba(16, 24, 32, 0.1)',
            padding: '10px 14px',
            fontSize: '12px',
            fontWeight: 600
          }}
          cursor={{ fill: 'rgba(0, 102, 255, 0.05)', radius: 8 }}
          labelStyle={{ color: '#101820', fontWeight: 700, marginBottom: '4px' }}
        />
        <Legend 
          wrapperStyle={{ fontSize: '11px', fontWeight: 600, paddingTop: '8px' }}
          iconType="circle"
          iconSize={8}
        />
        {dataKeys.map((key, index) => (
          <Bar
            key={key.dataKey}
            dataKey={key.dataKey}
            name={key.name}
            fill={`url(#bar-gradient-${index})`}
            radius={horizontal ? [0, 10, 10, 0] : [10, 10, 0, 0]}
            barSize={horizontal ? 24 : 32}
            maxBarSize={50}
          />
        ))}
      </RechartsBarChart>
    </ResponsiveContainer>
  );
};

export default BarChart;
